import DOMPurify from "dompurify";
import React from "react";
import { Send, Loader2, CheckCircle2, AlertCircle, Trash2, Eye } from "lucide-react";

const statusCls = (s) =>
  s === "envoyee" ? "bg-emerald-100 text-emerald-700" : s === "programmee" ? "bg-blue-100 text-blue-700" : "bg-neutral-200 text-neutral-600";

export const CampaignCard = ({ c, running, onPreview, onLaunch, onRemove }) => (
  <div className="bg-white border border-neutral-200 rounded-xl p-5" data-testid={`campaign-card-${c.id}`}>
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <div className="flex items-center gap-2">
          <span className="font-semibold text-neutral-900">{c.nom}</span>
          <span className={`text-xs font-semibold px-2 py-0.5 rounded ${statusCls(c.status)}`}>{c.status}</span>
        </div>
        <p className="text-sm text-neutral-500 mt-1">
          {c.kind === "relance" ? "Relance" : "Prospection"} · {c.prospect_ids?.length || 0} destinataires
          {(c.ville || c.region) && ` · ${c.ville || c.region}`}
          {c.status === "programmee" && c.scheduled_at && ` · ⏰ ${new Date(c.scheduled_at).toLocaleString("fr-FR")}`}
          {c.status === "envoyee" && ` · ${c.sent_count} envoyés`}
        </p>
      </div>
      <div className="flex items-center gap-2">
        {c.html_body && (
          <button onClick={() => onPreview(c)} className="flex items-center gap-1.5 text-sm text-neutral-600 hover:text-brand border border-neutral-300 px-3 py-1.5 rounded-md"><Eye size={15} /> Aperçu</button>
        )}
        {c.status !== "envoyee" && (
          <button onClick={() => onLaunch(c.id)} disabled={running} data-testid={`campaign-launch-${c.id}`} className="flex items-center gap-2 bg-brand hover:bg-brand-dark text-white text-sm font-semibold px-4 py-1.5 rounded-md disabled:opacity-60">
            {running ? <Loader2 size={15} className="animate-spin" /> : <Send size={15} />} {running ? "Envoi..." : "Lancer"}
          </button>
        )}
        <button onClick={() => onRemove(c.id)} className="text-neutral-400 hover:text-red-500 p-1.5"><Trash2 size={16} /></button>
      </div>
    </div>
    {c.results?.length > 0 && (
      <div className="mt-3 pt-3 border-t border-neutral-100 grid sm:grid-cols-2 gap-1.5">
        {c.results.map((r, i) => (
          <div key={`${r.prospect_id || r.societe || "r"}-${i}`} className="flex items-center gap-2 text-xs">
            {r.status === "sent" ? <CheckCircle2 size={13} className="text-emerald-500" /> : <AlertCircle size={13} className="text-amber-500" />}
            <span className="text-neutral-600 truncate">{r.societe} — {r.status}</span>
          </div>
        ))}
      </div>
    )}
  </div>
);

export const CampaignPreview = ({ campaign, onClose }) => (
  <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose} data-testid="campaign-preview">
    <div className="bg-white rounded-2xl w-full max-w-xl max-h-[85vh] overflow-hidden flex flex-col" onClick={(e) => e.stopPropagation()}>
      <div className="px-5 py-3 border-b border-neutral-200 flex items-center justify-between">
        <span className="font-semibold text-sm">Objet : {campaign.subject}</span>
        <button onClick={onClose} className="text-neutral-400 hover:text-neutral-700 text-sm">Fermer</button>
      </div>
      <div className="overflow-y-auto" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(campaign.html_body || "") }} />
    </div>
  </div>
);
